import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { headersAuth } from '../../../../../../Services/AuthService';
import { servicios_grupogack_catalogo, tipo_regimen } from '../../../../../../Constants/Constants';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';

const TipoRegimen = ({ id, permisos }) => {
    const [ tiposRegimen, setTiposRegimen ] = useState( null );
    useEffect(() => {
        axiosTiposRegimen();
    }, []);

    const axiosTiposRegimen = () => {
        axios.get( `${servicios_grupogack_catalogo}/tiporegimen/`, headersAuth() )
            .then( respuesta => {
                //console.log( respuesta );
                switch( respuesta.data.status ){
                    case 200:
                        setTiposRegimen( respuesta.data.dataResponse );
                        break;
                    case 404:
                        //setTiposRegimen([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })
    }

    return (
        <div id={ id }>
            { tiposRegimen ?
                <DataTableService id={id} title={ tipo_regimen } permisos={permisos}
                    columns={[
                        { field: "regimenClave", title: "Clave" },
                        { field: "regimenDesc", title: "Descripción" },
                    ]}
                    data={ tiposRegimen } /> : <SpinnerOval />
            }
        </div>
    );
};

export default TipoRegimen;